// extracted by mini-css-extract-plugin
export default {"rect":"ReportCommentIcon_rect__c3fUp","iconGrey":"ReportCommentIcon_iconGrey__yPyew","circle":"ReportCommentIcon_circle__+PVdo","white":"ReportCommentIcon_white__LelSR"};